// extracted by mini-css-extract-plugin
export var alertPopup = "alert-popup-module--alert-popup--+vh-5";
export var alertPopupInner = "alert-popup-module--alert-popup-inner--Jw7-q";
export var alertPopupInnerClose = "alert-popup-module--alert-popup-inner-close--JnLQR";
export var alertPopupInnerMessage = "alert-popup-module--alert-popup-inner-message--lCesm";